<template>
  <div class="alert-box active">
    <span class="alert-text">
      {{ messageProp }}
      <span class="close" @click="close">x</span>
    </span>
  </div>
</template>

<script>
import { ALERT_TYPE } from "../mixins/constant-mixin";
import { Bus } from "../main";

export default {
  name: "PopUpAlert",
  props: {
    messageProp: {
      type: String
    },
    typeProp: {
      type: String
    }
  },
  data() {
    return {
      message: "",
    };
  },
  mounted() {
    this.open();
    Bus.$on("closeAlert", this.close);
  },
  beforeDestroy() {
    Bus.$off("closeAlert"); 
  },
  methods: {
    open: function () {
      let alertType = ALERT_TYPE.ERROR;
      if (this.typeProp) {
        alertType = this.typeProp;
      }
      this.$el.classList.add(alertType);
      const alerts = document.querySelectorAll(".alert-box");
      let height = 0;
      for (let i = 0; i < alerts.length-1; i++) {
        height += alerts[i].clientHeight + 10;
      }
      if (alertType === ALERT_TYPE.POP_UP_EDITOR_ERROR) {
        this.$el.style.transform = `translate(-50%, ${height}px)`
      } else {
        this.$el.style.transform = `translateY(${height}px)`
      }
      setTimeout(this.close, 4000); 
    },
    close: function () {
      this.$el.remove();
    },
  },
};
</script>

<style scoped>
.alert-box {
  z-index: 10;
  position: fixed;
  border-radius: 20px;
  max-width: 50vw;
  transition: opacity 0.2s linear;
  box-sizing: border-box;
  padding: 0.6rem 1.6rem;
  height: 0;
  visibility: hidden;
  opacity: 0;
}

.active {
  top: 2rem;
  height: auto;
  visibility: visible;
  opacity: 1;
  left: 40%;
}

.error {
  background: #f44336;
  box-shadow: 2px 2px 3px #6c0000;
}

.success {
  background: #04aa6d;
  box-shadow: 2px 2px 3px #005033;
}

.info {
  background: #2196f3;
  box-shadow: 2px 2px 3px #003056;
}

.popUpError {
  top: 5rem;
  background: #f44336;
  box-shadow: 2px 2px 3px #6c0000;
  left: 50%;
  transform: translateX(-50%);
}

.alert-text {
  color: #fff;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.close {
  margin-left: 1rem;
  padding: 0 0.5rem;
  cursor: pointer;
  margin-top: -3px;
}
</style>